import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * SSO Callback Handler
 * This component handles the OAuth callback and token extraction
 */
const SSOCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('🔄 SSOCallback component mounted');
    console.log('Full URL:', window.location.href);

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const isNewUser = urlParams.get('new');
    const provider = urlParams.get('provider');
    const error = urlParams.get('error');

    console.log('📋 Extracted params:', {
      token: token ? 'present' : 'none',
      isNewUser,
      provider,
      error
    });

    if (error) {
      console.error('❌ SSO Error:', error);
      navigate(`/login?error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }

    if (token) {
      console.log('✅ Token found, storing in localStorage');
      localStorage.setItem('authToken', token);

      const redirectPath = isNewUser === 'true' ? '/dashboard' : '/';
      console.log('🚀 Redirecting to:', redirectPath);

      // Force full page reload to trigger AuthContext validation
      window.location.href = redirectPath;
    } else {
      console.error('❌ No token found, redirecting to login');
      navigate('/login', { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing your sign-in...</p>
      </div>
    </div>
  );
};

export default SSOCallback;
